<template>
  <div id="fullPage" class="fullPage">

    <!-- Google Tag Manager (noscript) -->
    <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-KXSP9NN"
                      height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
    <!-- End Google Tag Manager (noscript) -->

    <div style="display: none!important;">
      <img id="BGgreen" src="../assets/images/flappyDigit/BGgreen.png" />
      <img id="BGgreen2" src="../assets/images/flappyDigit/BGgreen2.png" />
      <img id="BGviola" src="../assets/images/flappyDigit/BGviola.png" />
      <img id="BGviola2" src="../assets/images/flappyDigit/BGviola2.png" />
      <img id="BGyellow" src="../assets/images/flappyDigit/BGyellow.png" />
      <img id="BGyellow2" src="../assets/images/flappyDigit/BGyellow2.png" />
      <img id="eyes" src="../assets/images/flappyDigit/eyes.png" />
      <img id="digitdark" src="../assets/images/flappyDigit/digitdark.png" />
      <img id="digitdarkEyes" src="../assets/images/flappyDigit/digitdarkEyes.png" />
      <img id="digitwhite" src="../assets/images/flappyDigit/digitwhite.png" />
      <img id="digitwhiteEyes" src="../assets/images/flappyDigit/digitwhiteEyes.png" />
      <img id="Stardark" src="../assets/images/flappyDigit/Stardark.png" />
      <img id="Stargreen" src="../assets/images/flappyDigit/Stargreen.png" />
      <img id="Starlight" src="../assets/images/flappyDigit/Starlight.png" />
      <img id="Starviola" src="../assets/images/flappyDigit/Starviola.png" />
      <img id="Staryellow" src="../assets/images/flappyDigit/Staryellow.png" />
      <img id="prestizeHvezda" src="../assets/images/gemmedGame/gem6.png" />
      <img id="backgroundSnih" src="../assets/images/flappyDigit/vanoce/backgroundSnow.png" />
      <img id="pickupSrdce" src="../assets/images/flappyDigit/vanoce/srdickaL.png" />
      <img id="backgroundStatic" src="../assets/images/flappyDigit/vanoce/BG.png" />
      <img id="obstacleStrom1" src="../assets/images/flappyDigit/vanoce/strom1.png" />
      <img id="obstacleStrom2" src="../assets/images/flappyDigit/vanoce/strom2.png" />
      <img id="digitVanoce" src="../assets/images/flappyDigit/vanoce/Digit.png" />
      <img id="digitVanoceOci" src="../assets/images/flappyDigit/vanoce/digitOci.png" />

      <div v-if="$i18n.locale == 'cs'" id="text1">Připraveni?</div>
      <div v-if="$i18n.locale == 'cs'" id="text2">Pro spuštění hry</div>
      <div v-if="$i18n.locale == 'cs'" id="text2b">kdekoliv klikněte.</div>
      <div v-if="$i18n.locale == 'en'" id="text1">Ready?</div>
      <div v-if="$i18n.locale == 'en'" id="text2">Click anywhere</div>
      <div v-if="$i18n.locale == 'en'" id="text2b">to start the game.</div>
      <div v-if="$i18n.locale == 'sk'" id="text1">Pripravený na vianočné dobrodružstvo?</div>
      <div v-if="$i18n.locale == 'sk'" id="text2">Ťukni kdekoľvek na displeji</div>
      <div v-if="$i18n.locale == 'sk'" id="text2b">a hra začína!</div>
      <div v-if="$i18n.locale == 'cs'" id="textScoreLevel">úroveň:</div>
      <div v-if="$i18n.locale == 'en'" id="textScoreLevel">level:</div>
      <div v-if="$i18n.locale == 'sk'" id="textScoreLevel">Úroveň:</div>
    </div>
    <div id="outsideGameScreensWrapper">
      <div id="startScreen" class="startScreen">
        <div class="startScreenHeroImgWrapper">
          <img class="initImg" src="../assets/images/flappyDigit/vanoce/digitHero.png" />
        </div>
        <div class="startScreenSubtitle colorMagenta">
          <span v-if="$i18n.locale == 'cs'">VÁNOČNÍ</span>
          <span v-if="$i18n.locale == 'en'">Christmas</span>
          <span v-if="$i18n.locale == 'sk'"></span>
        </div>
        <div class="startScreenTitle colorWhite mBottom12">
          <span v-if="$i18n.locale == 'cs'">World of Digit</span>
          <span v-if="$i18n.locale == 'en'">World of Digit</span>
          <span v-if="$i18n.locale == 'sk'">Vianočná srdiečková misia s Digitom</span>
        </div>
        <div class="startScreenText colorWhite mBottom29">
          <span v-if="$i18n.locale == 'cs'">Ponořte se do vánočního světa malého Digitu <span class="nbsp">a po</span> cestě sbírejte srdíčka. Čím víc jich nasbíráte, tím větší získáte odměnu. Srdíčka se vám budou hodit na další vánoční soutěže. Připraveni na dobrodružství?</span>
          <span v-if="$i18n.locale == 'en'">Dive into the Christmas World of little Digit and collect hearts along the way. The more hearts you collect, the bigger the reward you'll get. The hearts will come in handy for other Christmas contests. Ready for an adventure?</span>
          <span v-if="$i18n.locale == 'sk'">Vstúp do čarovného vianočného sveta malého Digita a pomôž mu nazbierať čo najviac srdiečok! Každé srdiečko sa počíta - čím viac ich máš, tým väčšia odmena vo forme Magenta srdiečok ťa čaká. Zídu sa ti v našich exkluzívnych vianočných súťažiach! Tak čo, si pripravený na dobrodružstvo?</span>
        </div>
        <div class="startScreenBtnWrapper">
          <div class="initBtn width211 colorWhite startScreenPlayBtn mBottom9" @click="game(), spustitHruAnalitika()">
            <span v-if="$i18n.locale == 'cs'">Spustit hru</span>
            <span v-if="$i18n.locale == 'en'">Start the game</span>
            <span v-if="$i18n.locale == 'sk'">Spustiť hru</span>
          </div>
          <div class="initBtn width211 colorWhite startScreenHowPlayBtn" @click="jakHrat()">
            <span v-if="$i18n.locale == 'cs'">Jak hrát?</span>
            <span v-if="$i18n.locale == 'en'">How to play?</span>
            <span v-if="$i18n.locale == 'sk'">Ako hrať?</span>
          </div>
        </div>
        <div class="snihDoleBackground">
          <img class="initImg" src="../assets/images/flappyDigit/vanoce/snihDoleBackground.png" />
        </div>
      </div>
      <div id="jakHratScreen" class="jakHratScreen" style="padding: 0px;">
        <div style="position: relative; z-index: 100000; max-height: 100%; overflow: scroll; padding-right: 20px; padding-left: 20px; overscroll-behavior: none;">
          <div class="jakHratTopSpacer"></div>
          <div class="jakHratKostkaVisualWrapper mBottom35">
            <div class="jakHratKostkaVisual"></div>
          </div>
          <div class="jakHratScreenTitle colorWhite mBottom8">
            <span v-if="$i18n.locale == 'cs'">Jak hrát?</span>
            <span v-if="$i18n.locale == 'en'">How to play?</span>
            <span v-if="$i18n.locale == 'sk'">Ako sa to hrá?</span>
          </div>
          <div class="jakHratScreenText colorWhite mBottom35">
            <span v-if="$i18n.locale == 'cs'">Hru ovládáte dotykem kdekoliv na displeji. Kliknutím na displej dostanete Digit kostičku <span class="nbsp">o kousek</span> výš <span class="nbsp">a vyhnete</span> se tak překážkám. Cestou sbírejte srdíčka, která na konci hry proměníte na Srdíčka <span class="nbsp">v Magenta</span> Moments.</span>
            <span v-if="$i18n.locale == 'en'">You control the game by touching anywhere on the screen. Click on the screen to move the Digit cube a bit higher and avoid obstacles. Collect hearts along the way, which you will convert into Hearts in Magenta Moments at the end of the game.</span>
            <span v-if="$i18n.locale == 'sk'">Ťukni kdekoľvek na displeji a Digit vyskočí o kúsok vyššie! Vyhýbaj sa prekážkam a cestou zbieraj srdiečka a oči. Nazbierané srdiečka ťa postupne dostávajú do vyššej úrovne hry, získané oči ťa udržia v hre aj keď narazíš do prekážky. Znie to jednoducho? Tak poď, ukáž čo v tebe je!</span>
          </div>
          <div class="jakHratScreenTitle colorWhite mBottom8">
            <span v-if="$i18n.locale == 'cs'">O co se hraje?</span>
            <span v-if="$i18n.locale == 'en'">What's the game about?</span>
            <span v-if="$i18n.locale == 'sk'">O čo hráš?</span>
          </div>
          <div class="jakHratScreenText colorWhite mBottom32">
            <span v-if="$i18n.locale == 'cs'">Ve hře je celkem <span class="nbsp">5 úrovní</span> podle toho, kolik srdíček <span class="nbsp">s Digitem</span> seberete. Za každou dosaženou úroveň získáte za odměnu Srdíčka do Magenta Moments. Vyšší úroveň znamená větší odměnu. Hrát můžete <span class="nbsp">do 31. 12.</span></span>
            <span v-if="$i18n.locale == 'en'">The game has a total of 5 levels depending on how many hearts you collect   with Digit. For each level reached, you will be rewarded with Hearts in Magenta Moments. A higher level means a bigger reward. You can play until   December 31st.</span>
            <span v-if="$i18n.locale == 'sk'">Hra má 5 úrovní - čím viac srdiečok s Digitom pozbieraš, tým vyššiu úroveň v hre dosiahneš. Pozbierať môžeš maximálne 100 srdiečok. Každá úroveň ti prinesie výhru v podobe Magenta srdiečok, ktoré si neskôr vymeníš za odmeny v Magenta Moments - vyššia úroveň znamená vyššiu výhru. Prejdi každú úroveň zvlášť a získaj spolu až 1000 srdiečok. Hrať môžeš až do 6.1.2026.</span>
          </div>
          <div class="startScreenBtnWrapper" style="margin-bottom: 40px;">
            <div class="initBtn width211 colorWhite startScreenPlayBtn" @click="game(), spustitHruAnalitika()">
              <span v-if="$i18n.locale == 'cs'">Spustit hru</span>
              <span v-if="$i18n.locale == 'en'">Start the game</span>
              <span v-if="$i18n.locale == 'sk'">Spustiť hru</span>
            </div>
          </div>
        </div>
        <div class="snihDoleBackground">
          <img class="initImg" src="../assets/images/flappyDigit/vanoce/snihDoleBackground.png" />
        </div>
      </div>
      <!-- <div id="feedBackScreen" class="feedBackScreen">
        <div class="topBackground">
          <img class="topBackgroundImg" src="../assets/images/flappyDigit/BGviola.png" />
        </div>
        <div class="bottomBackground">
          <img class="bottomBackgroundImg" src="../assets/images/flappyDigit/BGviola2.png" />
        </div>
        <div class="jakHratTopSpacer"></div>
        <div class="jakHratKostka"></div>
        <div class="jakHratNadpis">
          Vaše nápady
        </div>
        <div class="jakHratText" style="margin-bottom: 32px;">
          Máte pro nás zpětnou vazbu nebo nápad na zlepšení? Sem <span class="nbsp">s tím!</span> Rádi hru vylepšíme podle vašich tipů <span class="nbsp">a připomínek.</span>
        </div>
        <div style="padding-left: 20px; padding-right: 20px; padding-bottom: 18px; position: relative; z-index: 2; display: grid;">
					<textarea v-if="!feedback_odeslan" name="custom_answer" class="custom_answer" v-model="feedback_answer" placeholder="Sem můžete psát vaše postřehy"></textarea>
          <div v-if="feedback_odeslan" class="feedbackOdeslanText" style="place-self: center; transform: translateY(-14px);">
            Děkujeme za Vaši zpětnou vazbu :)
          </div>
        </div>
        <div class="feedbackBtnWrapper" style="margin-bottom: 52px;">
          <div class="feedbackZpetBtn" @click="zpetNaStartScreen()">
            Zpět
          </div>
          <div class="feedbackOdeslatBtn" :class="feedback_answer != '' ? 'feedbackOdeslatBtnActive' : ''" @click="odeslatFeedback()">
            Odeslat
          </div>
        </div>
      </div> -->
      <div id="endGameScreen" class="endGameScreen">
        <div class="startScreenHeroImgWrapper">
          <img class="initImg" src="../assets/images/flappyDigit/vanoce/digitHero.png" />
        </div>
        <div class="jakHratScreenTitle colorWhite mBottom12">
          <span v-if="$i18n.locale == 'cs'">Vaše skóre: {{ pocetSebranychSrdicek }} <img class="maleSrdickoScore" src="../assets/images/flappyDigit/vanoce/srdickaS.png" /></span>
          <span v-if="$i18n.locale == 'en'">Your Score: {{ pocetSebranychSrdicek }} <img class="maleSrdickoScore" src="../assets/images/flappyDigit/vanoce/srdickaS.png" /></span>
          <span v-if="$i18n.locale == 'sk'">Tvoje skóre: {{ pocetSebranychSrdicek }} <img class="maleSrdickoScore" src="../assets/images/flappyDigit/vanoce/srdickaS.png" /></span>
        </div>
        <div v-if="pocetSebranychSrdicek == 0" class="startScreenText colorWhite mBottom32">
          <span v-if="$i18n.locale == 'cs'">Tak tohle na vánoční odměnu nestačilo. Zkuste to <span class="nbsp">v tajuplném</span> světě Digitu znovu. Hrát <span class="nbsp">a zlepšovat</span> se můžete až do Silvestra.</span>
          <span v-if="$i18n.locale == 'en'"></span>
          <span v-if="$i18n.locale == 'sk'"></span>
        </div>
        <div v-if="pocetSebranychSrdicek != 0" class="startScreenText colorWhite mBottom32">
          <span v-if="$i18n.locale == 'cs'">Podařilo se vám dosáhnout úrovně {{ urovenPodleSrdicek }}. Získáváte za odměnu {{ srdickaPodleUrovne }} Srdíček. Vyzvedněte si je hned, jinak se vám odměna ztratí.</span>
          <span v-if="$i18n.locale == 'en'">You have reached level {{ urovenPodleSrdicek }}. You earn {{ srdickaPodleUrovne }} Hearts as a reward. Claim them now, or your reward will be lost.</span>
          <span v-if="$i18n.locale == 'sk'">Wow! Dosiahol si úroveň {{ urovenPodleSrdicek }} - to si Digit vyskočil radosťou až po vianočnú hviezdu! Za tvoj výkon získavaš {{ srdickaPodleUrovne }} srdiečok, ktoré čakajú len na teba. Ale pozor - odmena nepočká večne! Vyzdvihni si ju teraz, kým nezmizne ako snehová vločka v Decembri.</span>
        </div>
        <div v-if="pocetSebranychSrdicek == 0" class="startScreenBtnWrapper">
          <div class="initBtn width280 colorWhite startScreenPlayBtn mBottom9" @click="playAgaing()">
            <span v-if="$i18n.locale == 'cs'">Hrát znovu</span>
            <span v-if="$i18n.locale == 'en'">Play Again</span>
            <span v-if="$i18n.locale == 'sk'">Zahrám si znova</span>
          </div>
          <div class="initBtn width280 colorWhite startScreenHowPlayBtn" @click="backToCalendar()">
            <span v-if="$i18n.locale == 'cs'">Zpět do Adventního kalendáře</span>
            <span v-if="$i18n.locale == 'en'">Back to the Advent Calendar</span>
            <span v-if="$i18n.locale == 'sk'">Späť do Magenta Moments</span>
          </div>
        </div>
        <div v-if="pocetSebranychSrdicek != 0" class="startScreenBtnWrapper">
          <div class="initBtn width211 colorWhite startScreenPlayBtn mBottom9" @click="vyzvednoutSrdicka()">
            <span v-if="$i18n.locale == 'cs'">Vyzvednout odměnu</span>
            <span v-if="$i18n.locale == 'en'">Claim Reward</span>
            <span v-if="$i18n.locale == 'sk'">Vyzdvihnúť odmenu</span>
          </div>
          <div class="initBtn width211 colorWhite startScreenHowPlayBtn" @click="playAgaing()">
            <span v-if="$i18n.locale == 'cs'">Hrát znovu</span>
            <span v-if="$i18n.locale == 'en'">Play Again</span>
            <span v-if="$i18n.locale == 'sk'">Skúsiť to znova</span>
          </div>
        </div>
        <div class="snihDoleBackground">
          <img class="initImg" src="../assets/images/flappyDigit/vanoce/snihDoleBackground.png" />
        </div>
      </div>
    </div>
    <canvas id="game_canvas" class="hidden_canvas">

    </canvas>
  </div>
</template>

<script>
import Game from "../digitSkakackaJS/Game";
import store from "../store";
import BffAPI from "@/service/BffAPI";

export default {
  name: "flappyDigitMicrosite.vue",
  computed: {
    urovenPodleSrdicek() {
      if(this.pocetSebranychSrdicek > 0 && this.pocetSebranychSrdicek <= 7) {
        return 1
      } else if(this.pocetSebranychSrdicek > 7 && this.pocetSebranychSrdicek <= 20) {
        return 2
      } else if(this.pocetSebranychSrdicek > 20 && this.pocetSebranychSrdicek <= 45) {
        return 3
      } else if(this.pocetSebranychSrdicek > 45 && this.pocetSebranychSrdicek <= 80) {
        return 4
      } else if(this.pocetSebranychSrdicek > 80) {
        return 5
      } else {
        return 0
      }
    },
    srdickaPodleUrovne() {
      if(this.urovenPodleSrdicek == 1) {
        return 100
      } else if(this.urovenPodleSrdicek == 2) {
        return 150
      } else if(this.urovenPodleSrdicek == 3) {
        return 200
      } else if(this.urovenPodleSrdicek == 4) {
        return 250
      } else if(this.urovenPodleSrdicek == 5) {
        return 300
      } else {
        return 0
      }
    },
    store() {
      return store
    },
    isIOS() {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const platform = navigator.platform;

      console.log(navigator.userAgent)
      console.log(navigator.vendor)
      console.log(window.opera)
      return /iPad|iPhone|iPod/.test(userAgent) && !/Edg|Windows|Macintosh/.test(userAgent) && /iPhone|iPad|iPod/.test(platform);
    }
  },
  data() {
    return {
      storedScore: 0,
      storePocetHvezd: 0,
      currentScore: 0,
      feedback_answer: '',
      feedback_odeslan: false,
      pocetSebranychSrdicek: 0,
      historyReset: [true, true]
    }
  },
  methods: {
    game() {

      let $thisKeyWord = this

      if ($thisKeyWord.historyReset[0]) {
        history.pushState({ state: 'game_initial_load' }, '', null);
        $thisKeyWord.historyReset[0] = false;
      }

      const outsideGameScreensWrapper = document.getElementById('outsideGameScreensWrapper')
      outsideGameScreensWrapper.style.display = "none"

      const screenWidth = window.innerWidth
      const screenHeight = window.innerHeight
      const screenRation = screenHeight / screenWidth;

      const canvas = document.getElementById("game_canvas")
      canvas.classList.remove('hidden_canvas')
      canvas.style.height = window.innerHeight + "px";
      canvas.width = 500;
      canvas.height = canvas.width * screenRation;

      const sRatioX = canvas.width / screenWidth
      const sRatioY = canvas.height / screenHeight

      const canvas_context = canvas.getContext('2d')

      const game = new Game(canvas.width, canvas.height, sRatioX, sRatioY)

      let animationFrameID = 0
      let lastTime = 0
      let deltaTime = 0

      function gameLoop(timeStamp) {
        deltaTime = timeStamp - lastTime
        lastTime = timeStamp
        canvas_context.clearRect(0,0, canvas.width, canvas.height)

        game.update(deltaTime)
        game.draw(canvas_context)

        animationFrameID = requestAnimationFrame(gameLoop)

        if(game.gameEnded == true) {

          if ($thisKeyWord.historyReset[0]) {
            history.pushState({ state: 'game_initial_load' }, '', null);
            $thisKeyWord.historyReset[0] = false;
          }
          $thisKeyWord.pocetSebranychSrdicek = game.srdickaScore

          stopAnimationFrame(animationFrameID)

          const outsideGameScreensWrapper = document.getElementById('outsideGameScreensWrapper')
          outsideGameScreensWrapper.style.display = "block"
          const startScreen = document.getElementById('startScreen')
          startScreen.style.display = "none"
          // const feedBackScreen = document.getElementById('feedBackScreen')
          // feedBackScreen.style.display = "none"
          const jakHratScreen = document.getElementById('jakHratScreen')
          jakHratScreen.style.display = "none"
          const endGameScreen = document.getElementById('endGameScreen')
          endGameScreen.style.display = "block"
          const canvas = document.getElementById("game_canvas")
          canvas.classList.add('hidden_canvas')
        }
      }

      gameLoop(0)

      function stopAnimationFrame(animationFrameID) {
        cancelAnimationFrame(animationFrameID)
        console.log("animationStoped: " + animationFrameID)
      }
    },
    GTM_function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    },
    backToCalendar() {
      location.href = "telekomsk://magentaFeed"
    },
    vyzvednoutSrdicka() {
      window.dataLayer.push({
        'event': 'AK_Digit',
        'click_detail': 'button_click',
        'click_info': 'Chcem_sutazit'
      });

      if(this.urovenPodleSrdicek == 1) {
        location.href = "telekomsk://magentaFeed/offerDetails/69580"
      } else if(this.urovenPodleSrdicek == 2) {
        location.href = "telekomsk://magentaFeed/offerDetails/69581"
      } else if(this.urovenPodleSrdicek == 3) {
        location.href = "telekomsk://magentaFeed/offerDetails/69592"
      } else if(this.urovenPodleSrdicek == 4) {
        location.href = "telekomsk://magentaFeed/offerDetails/69593"
      } else if(this.urovenPodleSrdicek == 5) {
        location.href = "telekomsk://magentaFeed/offerDetails/69594"
      }
    },

    odeslatFeedback() {
      if(this.feedback_answer != '') {
        var feedbackKOdeslani = {
          "formName": "FlappyDigit Feedback",
          "repeaterAnswer": true,
          //"userId": "testUserId",
          "answerList": [
            {
              "question": "Feedback",
              "userValue": this.feedback_answer.toString()
            }
          ]
        }
        this.feedback_odeslan = true
        this.feedback_answer = ''
        BffAPI.sendFormData(feedbackKOdeslani, this.$store.state.jwt)
      }
    },
    spustitHruAnalitika() {
      window.dataLayer.push({
        'event': 'AK_Digit',
        'click_detail': 'button_click',
        'click_info': 'Spustit_hru_btn'
      });
    },
    playAgaing() {
      if (this.historyReset[0]) {
        history.pushState({ state: 'game_initial_load' }, '', null);
        this.historyReset[0] = false;
      }

      const startScreen = document.getElementById('startScreen')
      startScreen.style.display = "none"
      // const feedBackScreen = document.getElementById('feedBackScreen')
      // feedBackScreen.style.display = "none"
      const jakHratScreen = document.getElementById('jakHratScreen')
      jakHratScreen.style.display = "none"
      const endGameScreen = document.getElementById('endGameScreen')
      endGameScreen.style.display = "none"
      const outsideGameScreensWrapper = document.getElementById('outsideGameScreensWrapper')
      outsideGameScreensWrapper.style.display = "none"
      this.game()

      window.dataLayer.push({
        'event': 'AK_Digit',
        'click_detail': 'button_click',
        'click_info': 'Hrat_znova_btn'
      });
    },
    zpetNaStartScreen() {
      const startScreen = document.getElementById('startScreen')
      startScreen.style.display = "block"
      // const feedBackScreen = document.getElementById('feedBackScreen')
      // feedBackScreen.style.display = "none"
      const jakHratScreen = document.getElementById('jakHratScreen')
      jakHratScreen.style.display = "none"

      window.dataLayer.push({
        'event': 'AK_Digit',
        'click_detail': 'button_click',
        'click_info': 'Feedback_Spat_btn'
      });
    },
    feedBack() {
      // const startScreen = document.getElementById('startScreen')
      // startScreen.style.display = "none"
      // const jakHratScreen = document.getElementById('jakHratScreen')
      // jakHratScreen.style.display = "none"
      // const feedBackScreen = document.getElementById('feedBackScreen')
      // feedBackScreen.style.display = "grid"

      // window.dataLayer.push({
      //   'event': 'AK_Digit',
      //   'click_detail': 'button_click',
      //   'click_info': 'feedback_btn'
      // });
    },
    jakHrat() {
      if (this.historyReset[0]) {
        history.pushState({ state: 'game_initial_load' }, '', null);
        this.historyReset[0] = false;
      }
      const startScreen = document.getElementById('startScreen')
      startScreen.style.display = "none"
      // const feedBackScreen = document.getElementById('feedBackScreen')
      // feedBackScreen.style.display = "none"
      const jakHratScreen = document.getElementById('jakHratScreen')
      jakHratScreen.style.display = "block"

      window.dataLayer.push({
        'event': 'AK_Digit',
        'click_detail': 'button_click',
        'click_info': 'Ako_sa_to_hra_btn'
      });
    },
    doMagentaMoments() {
      location.href = "telekom://magentaFeed"
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    const that = this;
    const main_container = document.getElementById("fullPage")
    main_container.scrollIntoView();

    document.title = "Vianočná srdiečková misia s Digitom"
    this.$i18n.locale = this.$route.name === 'flappyVanocniDigitMicrosite' ? 'cs' : 'sk';

    const storedHighScore = localStorage.getItem('highScore');
    const pocetHvezdicekCelkem = localStorage.getItem('starsCount');

    if (storedHighScore !== null) {
      this.storedScore = parseInt(storedHighScore, 10);
      if(pocetHvezdicekCelkem !== null) {
        this.storePocetHvezd = parseInt(pocetHvezdicekCelkem, 10);
      }
    }

    window.oncontextmenu = function() {
      return false;
    }

    window.onpopstate = function() {
      that.historyReset[0] = true;
      that.zpetNaStartScreen();
    }

    if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      const htmlTag = document.querySelector("html")
      htmlTag.style.background = 'linear-gradient(to bottom, #202020 0%, #202020 100%)';
      const bodyTag = document.querySelector("body")
      bodyTag.style.background = 'linear-gradient(to bottom, #202020 0%, #202020 100%)';
      htmlTag.style.overflow = "hidden"
      bodyTag.style.overflow = "hidden"
    } else {
      const htmlTag = document.querySelector("html")
      htmlTag.style.background = 'linear-gradient(to bottom, #F1F1F1 0%, #F1F1F1 90%)';
      const bodyTag = document.querySelector("body")
      bodyTag.style.background = 'linear-gradient(to bottom, #F1F1F1 0%, #F1F1F1 90%)';
      htmlTag.style.overflow = "hidden"
      bodyTag.style.overflow = "hidden"
    }

    const canvas = document.getElementById("game_canvas")
    if(!canvas.classList.contains('hidden_canvas')) {
      canvas.classList.add('hidden_canvas')
    }

    this.GTM_function(window,document,'script','dataLayer','GTM-WW7D6K');

    window.dataLayer.push({
      'event': 'AK_Digit',
      'click_detail': 'nacitanie_stranky'
    });
  }
}
</script>

<style scoped>
.jakHratKostkaVisual {
  width: 81px;
  height: 81px;
  background-color: #e20074;
}
.jakHratKostkaVisualWrapper {
  width: fit-content;
  margin: 0 auto;
}
.jakHratTopSpacer {
  height: 58px;
  width: 100%;
}
.startScreenHeroImgWrapper {
  width: 100%;
}
.initImg {
  display: block;
  width: 100%;
}
.startScreen, .jakHratScreen, .endGameScreen {
  position: relative;
  background-image: url("../assets/images/flappyDigit/vanoce/BG.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  padding-right: 20px;
  padding-left: 20px;
}
.snihDoleBackground {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}
.startScreenSubtitle {
  font-family: "TeleNeoLocalExtraBold";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 18px;
  font-style: italic;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  position: relative;
  z-index: 2;
}
.startScreenTitle {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 36px;
  font-weight: 800;
  line-height: 38px;
  text-align: center;
  font-variation-settings: 'wdth' 136;
  position: relative;
  z-index: 2;
}
.startScreenText {
  font-family: "TeleNeoLocalExtraBold";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 17px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  position: relative;
  z-index: 2;
}
.jakHratScreenTitle {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 32px;
  font-weight: 800;
  line-height: 32px;
  text-align: center;
  font-variation-settings: 'wdth' 136;
}
.jakHratScreenText {
  font-family: "TeleNeoLocalExtraBold";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 18px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
}
.startScreenBtnWrapper {
  width: fit-content;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.initBtn {
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  height: 46px;
  font-family: "TeleNeoLocalExtraBold";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 20px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
}
.startScreenPlayBtn {
  border: 3px solid #FFFFFF;
  background-color: #e20074;
}
.startScreenHowPlayBtn {
  border: 3px solid #e20074;
  background-color: #000000;
}
.maleSrdickoScore {
  width: 23px;
  transform: translateY(-3px);
}
.width211 {
  width: 211px;
}
.width280 {
  width: 280px;
}
.colorWhite {
  color: #FFFFFF;
}
.colorMagenta {
  color: #e20074;
}
.mBottom8 {
  margin-bottom: 8px;
}
.mBottom9 {
  margin-bottom: 9px;
}
.mBottom12 {
  margin-bottom: 12px;
}
.mBottom29 {
  margin-bottom: 29px;
}
.mBottom32 {
  margin-bottom: 32px;
}
.mBottom35 {
  margin-bottom: 35px;
}
@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
.rotateImage {
  animation: rotate360 30s linear infinite;
}
.custom_answer {
  background-color: #FFFFFF;
  border: 3px solid #A49DF1;
  color: #000000;
  width: 100%;
  height: 100%;
  font-family: "TeleNeoLocalExtraBold";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 16px;
  font-weight: 800;
  line-height: 18px;
  letter-spacing: -0.30000001192092896px;
  text-align: left;
  padding: 12px;

  -webkit-appearance: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.custom_answer:active, .custom_answer:focus {
  border: 3px solid #A49DF1;
  box-shadow: none !important;
  -webkit-appearance: none !important;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  outline: none !important;
}
.custom_answer::placeholder {
  color: #A49DF1;
  font-family: "TeleNeoLocalExtraBold";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 16px;
  font-weight: 800;
  line-height: 18px;
  letter-spacing: -0.30000001192092896px;
  text-align: left;
}
.feedbackBtnWrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 23px;
  padding: 0px 20px 0px 20px;
  width: 100%;
}
.endScreenNadpis {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 36px;
  font-weight: 800;
  line-height: 36px;
  text-align: center;
  font-variation-settings: 'wdth' 136;
  color: #202020;
  position: relative;
  z-index: 2;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 12px;
}
.feedbackOdeslatBtnActive {
  background-color: #EFDC34!important;
  border: 3px solid #4AD9CD!important;
  color: #202020!important;
}
.feedbackOdeslatBtn {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 20px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: #D6E5FC;
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  height: 46px;
  width: 100%;
  border: 3px solid #A49DF1;
  background-color: #ABBBF6;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.feedbackZpetBtn {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 20px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: #202020;
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  height: 46px;
  width: 100%;
  border: 3px solid #A49DF1;
  background-color: #FFFFFF;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.jakHratStartGameBtn {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 20px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: #202020;
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  height: 46px;
  width: 205px;
  border: 3px solid #A49DF1;
  background-color: #FFFFFF;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.jakHratText {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 18px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: #000000;
  margin-left: 15px;
  margin-right: 15px;
  margin-bottom: 55px;
  position: relative;
  z-index: 2;
}
.feedbackOdeslanText {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 18px;
  font-weight: 800;
  line-height: 20px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: #000000;
  z-index: 2;
}
.jakHratNadpis {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 36px;
  font-weight: 800;
  line-height: 36px;
  text-align: center;
  font-variation-settings: 'wdth' 136;
  color: #000000;
  margin-bottom: 8px;
  position: relative;
  z-index: 2;
}
.jakHratTopSpacer {
  height: 72px;
}
.jakHratKostka {
  width: 81px;
  height: 81px;
  background-color: #000000;
  margin: 0 auto;
  margin-bottom: 32px;
  position: relative;
  z-index: 2;
}
.topBackground {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}
.bottomBackground {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 1;
}
.topBackgroundImg, .bottomBackgroundImg {
  height: 150px;
}
.heroStartGameStarWrapper {
  position: absolute;
  width: fit-content;
  top:10px;
  right: 20px;
  z-index: 2;
}
.heroStartImg {
  width: 121px;
}
.startGameStarWrapper {
  margin: 0px 15px 0px 15px;
  position: relative;
  z-index: 0;
}
.startGameStar {
  width: 121px;
  transform: rotate(45deg);
  position: relative;
  z-index: 2;
}
.btnWrapper {
  width: fit-content;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.feedBackBtn {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 20px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: #000000;
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  height: 46px;
  width: 205px;
  border: 3px solid #4AD9CD;
  background-color: #FFFFFF;
  position: relative;
  z-index: 2;
}
.jakHratBtn {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 20px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: #000000;
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  height: 46px;
  width: 205px;
  border: 3px solid #CDDCF2;
  background-color: #A49DF1;
  position: relative;
  z-index: 2;
}
.startGameBtn {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 20px;
  font-weight: 800;
  line-height: 22px;
  letter-spacing: -0.30000001192092896px;
  text-align: center;
  color: #000000;
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  height: 46px;
  width: 205px;
  border: 3px solid #A49DF1;
  background-color: #EFDC34;
  position: relative;
  z-index: 2;
}
.startScreenNadpis {
  font-family: "TeleNeoLocalVariableUpright800";
  -webkit-font-smoothing: antialiased!important;
  text-rendering: optimizeLegibility!important;
  font-size: 42px;
  font-weight: 800;
  line-height: 42px;
  text-align: center;
  font-variation-settings: 'wdth' 136;
  color: #000000;
  position: relative;
  z-index: 2;
}
.startScreen, .jakHratScreen, .endGameScreen, .feedBackScreen {
  position: relative;
  height: 100vh;
}
.jakHratScreen, .endGameScreen, .feedBackScreen {
  display: none;
}
/* .feedBackScreen {
  grid-template-columns: 1fr;
  grid-template-rows: fit-content(100%) fit-content(100%) fit-content(100%) fit-content(100%) 1fr fit-content(100%);
} */
#outsideGameScreensWrapper {
  min-height: 100vh;
}
.heroImg {
  position: relative;
  z-index: 2;
  width: 100%;
}
.fullPage {
  display: block;
  grid-template-columns: 1fr;
  min-height: 100vh;
  overflow: hidden;
  touch-action: manipulation!important;
}
#game_canvas {
  position: relative;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background-color: #408E4D;
  touch-action: manipulation!important;
}
.hidden_canvas {
  display: none;
}
.startBtn {
  display: grid;
  grid-template-columns: 1fr;
  place-items: center;
  width: 100%;
  height: 46px;
  border-radius: 5px;
  background-color: #262626;
  color: #FFFFFF;
}
</style>